import { useTranslation } from 'react-i18next'

/**
 * Resolve a help text from a namespace-qualified i18n key ("<ns>:<key>").
 *
 * Returns an empty string both when the key does not exist and when its value is still an
 * empty stub — the caller renders nothing in either case. That is what makes it safe to ship
 * the full key catalogue before every text is written: a missing key never leaks as raw key
 * text into the UI.
 */
export function useHelpText(helpKey: string): string {
  const { t } = useTranslation()
  return t(helpKey, { defaultValue: '' }).trim()
}
